import React from "react";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ButtonPrimary from "../../../components/button-primary/ButtonPrimary";

import Process from '../../../static/images/Process.png';

import styles from './Benefits.module.scss';
import {VEDMARKET_LINKS} from '../../../constants';

function Benefits() {
    return (
        <div className={styles.benefits} id='features'>
            <Container className={styles.benefitsContainer}>
                <Row className={styles.benefitsContainerRow}>
                    <Col xl={6}>
                        <ul className={styles.list}>
                            <li className={styles.listItem}>
                                <span className={styles.number}>01.</span>
                                <span className={styles.benefit}>Рассчитывает полную стоимость товаров с&nbsp;учетом скрытых расходов</span>
                            </li>
                            <li className={styles.listItem}>
                                <span className={styles.number}>02.</span>
                                <span className={styles.benefit}>Собирает данные на&nbsp;услуги в&nbsp;реальном времени от&nbsp;ведущих компаний-партнеров</span>
                            </li>
                            <li className={styles.listItem}>
                                <span className={styles.number}>03.</span>
                                <span className={styles.benefit}>Обеспечивает прозрачность процессов и&nbsp;контроль на&nbsp;каждом этапе доставки</span>
                            </li>
                        </ul>
                    </Col>
                    <Col xl={6}>
                        <h3 className={styles.title}>Особенности</h3>
                        <h4 className={styles.subtitle}>Вэдмаркет&nbsp;&mdash; ваш цифровой ассистент для импорта</h4>
                        <p className={styles.text}>
                            Упрощает сложные процессы и&nbsp;помогает вам точно рассчитать все расходы на&nbsp;основе данных инвойса и&nbsp;упаковочного листа.
                        </p>
                        <ButtonPrimary href={VEDMARKET_LINKS.calculator} target="_blank" rel="noreferrer" label="Перейти к расчетам" isWide className={styles.buttonTop}/>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col xs={12} className={styles.benefitsProcessImage}>
                        <img src={Process} className={styles.image} alt="" />
                        <ButtonPrimary href={VEDMARKET_LINKS.calculator} target="_blank" rel="noreferrer" label="Перейти к расчетам" isWide className={styles.buttonBottom}/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Benefits;
